export default __webpack_public_path__ + "static/media/station-setup.84d3e674.png";